import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Admin from '../pages/admin-component/Admin';
import LoginPage from '../pages/auth/LoginPage';
import Loading from "../pages/auth/Loading";
import Loadingout from "../pages/auth/Loadingout";

class MainRoutes extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    {/* login routes test */}
                    <Route path="/" exact component={LoginPage} />
                    <Route path="/loading" exact component={Loading} />
                    {/* <Route path="/loading" exact component={Loading} /> */}
                    <Route path="/loadingout" exact component={Loadingout} />
                    {/* admin main routes */}
                    <Admin />
                </Switch>
            </Router>
        );
    }
}

export default MainRoutes;